export default {
    nav: {
        home: 'Home',
        products: 'Products',
        solutions: 'Solutions',
        support: 'Support',
        aboutUs: 'About Us',
        contact: 'Contact Us',
        software: 'Software'
    },
    hero: {
        title: 'Kooyii Smart',
        desc1: 'We can provide customized smart home APPs.',
        desc2: 'If you want an APP with your brand style, private servers...',
        desc3: 'Then we are your best choice.'
    },
    main1: {
        title: 'Custom Home Page',
        subtitle: 'The Kooyii app allows you to customize home page shortcuts based on your personal habits, making it easy to operate devices.',
        desc1: 'Cloud automatically syncs local date and time.',
        desc2: 'Add cameras to the home page to easily view video streams. Click to enter and use PTZ to adjust the camera direction.',
        desc3: 'Add door locks to the home page to conveniently unlock them remotely.',
        desc4: 'Cloud automatically syncs local weather and temperature.',
        desc5: 'Batch control arming and disarming of alarm hosts and gateways.',
        desc6: 'Add switches to the home page to quickly turn lights on/off.',
        desc7: 'Add curtains to the home page to quickly open/close/pause them.'
    },
    main2: {
        title: 'Device Management',
        subtitle: 'The Kooyii app displays devices by zone, allowing you to find and control them faster.',
        desc1: 'Selecting a zone displays the devices in that area.',
        desc2: 'Click to remotely control curtain open/close/pause and set forward/reverse rotation.',
        desc3: 'Click to remotely adjust light on/off, brightness, and color temperature.',
        desc4: 'Click to add/control TVs, air conditioners, etc.',
        desc5: 'Click to delete devices and assign them to specific zones.',
        desc6: 'Click to remotely turn lights on/off, set switch timers, 2-way control, etc.',
        desc7: 'Click to remotely arm/disarm gateways, add sub-devices, set screen-off background images, etc.',
        desc8: 'Click to operate VRF gateways for central air conditioning control.'
    },
    main3: {
        title: 'Smart Scenes & Automation',
        subtitle: 'Set up scenes and automations to achieve smart linkage across all devices in your house.',
        desc1: 'Click to switch between scenes and automation.',
        desc2: 'Click to enter the edit page to modify or delete action commands within a scene.',
        desc3: 'Click to add a scene/automation, select the device and the action to execute. It takes effect upon completion.',
        desc4: 'Click to execute preset smart scenes with one tap.'
    },
    about: {
        title: 'About Us',
        desc1: 'Kooyii is a comprehensive mobile APP independently developed by Shenzhen Golden Security Technology Co., Ltd., integrating smart home and security alarms. Through the APP, users can add and control devices, set automation scenes, and receive alarms anytime, anywhere.',
        desc2: 'The APP supports controlling smart devices across multiple protocols, covering various application scenarios such as smart homes, security alarms, smart hotels, and building automation.',
        desc3: 'As a high-tech enterprise integrating R&D, production, and sales, we provide customers with services such as hardware development, software customization, and private deployment to meet diverse needs.'
    },
    protocol: {
        title: 'Supported Protocols',
        cards: {
            zigbee: 'Zigbee 3.0 is a unified wireless communication standard introduced by the Connectivity Standards Alliance (CSA), enabling seamless cross-brand interoperability and low-power mesh networking by integrating fragmented application protocols.',
            wifi: 'Wi-Fi is a globally recognized wireless networking technology that transmits data via radio waves, allowing devices to connect to networks without physical cables.',
            rf433: '433MHz is a low-frequency radio band commonly used for short-range, low-power devices such as security alarm systems and smart switches.',
            modbus: 'Modbus is a serial communication protocol widely used in industrial automation, supporting master-slave communication and data exchange.',
            knx: 'KNX is a European standard bus technology widely used in building automation systems for smart buildings.',
            bluetooth: 'Bluetooth is a wireless technology for inter-device communication, widely used in smart hotels, smart homes, and other fields.'
        }
    },
    features: {
        title: 'What you can do with this App',
        remoteControl: {
            title: 'Remote Control',
            desc: 'Control smart devices remotely.'
        },
        armDisarm: {
            title: 'Arm/Disarm',
            desc: 'Set arm/disarm modes for the alarm host.'
        },
        alarmPush: {
            title: 'Receive Alarms',
            desc: 'Receive instant notifications on your phone when the home alarm host is triggered.'
        },
        scenes: {
            title: 'Smart Scenes',
            desc: 'Set up one-tap execution based on different scenario needs.'
        },
        automation: {
            title: 'Automation',
            desc: 'Automation allows your devices to execute commands automatically when specific conditions are met.'
        },
        familyShare: {
            title: 'Family Sharing',
            desc: 'Invite family members to manage devices together.'
        }
    },
    services: {
        title: 'Application Scenarios',
        features: {
            smartHome: {
                title: 'Smart Home',
                desc: 'Break the limitations of traditional homes to create a full-scenario smart living space. Supporting multiple protocols like Zigbee and Wi-Fi, it enables device interconnectivity and seamless scene switching. Unlock a highly efficient and convenient lifestyle with minimalist operations, bringing tech-driven warmth to your living experience.'
            },
            security: {
                title: 'Smart Security',
                desc: 'A security alarm host paired with a professional monitoring platform to build an integrated security system. As the core of the system, the host connects to various detectors (infrared, smoke, emergency buttons) via the 433MHz protocol, enabling real-time alerts for intrusions, fires, and emergencies.'
            },
            hotel: {
                title: 'Smart Hotel',
                desc: 'Centered around IoT and paired with a hotel equipment management platform, this solution connects smart guest rooms, front desk operations, and room services, delivering dual value to both guests and hotel management.'
            },
            building: {
                title: 'Building Automation',
                desc: 'Based on RTU and configured through a management backend, it supports Modbus device integration to easily achieve centralized monitoring, smart control, and energy management of building equipment, upgrading traditional buildings into smart ones.'
            }
        }
    },
    software: {
        title: 'Software & Platforms',
        steps: {
            cms: { title: 'Alarm Receiving Center', desc: 'Click to visit' },
            kooyii: { title: 'Kooyii', desc: 'Hover to scan and download' },
            elderly: { title: 'Smart Eldercare', desc: 'Experience not yet available. Contact sales for details.' },
            hotel: { title: 'Smart Hotel', desc: 'Click to experience.' },
            building: { title: 'Building Automation', desc: 'Experience not yet available. Contact sales for details.' },
            more: { title: 'More Scenarios', desc: 'Please contact sales for professional advice.' }
        }
    },
    solutions: {
        services: {
            title: 'Our Services',
            features: {
                hardware: {
                    title: 'Hardware Customization',
                    desc: 'One-stop exclusive design and manufacturing services from core PCBA boards to full device aesthetics. Covers circuit design, component selection, PCB layout, functional debugging, casing molds, materials, and structural protection.'
                },
                software: {
                    title: 'Software Customization',
                    desc: 'Tailor-made app and web system development based on your actual business needs, including mobile apps (iOS/Android), PC web pages, and backend management. Providing a highly efficient digital solution tailored to your operational model.'
                },
                server: {
                    title: 'Private Deployment',
                    desc: 'Deploy systems, platforms, or applications entirely on your own servers or designated intranet environments. Data and services run completely independently, achieving full autonomous control.'
                }
            }
        },
        whyUs: {
            title: 'Why Choose Us?',
            benefits: {
                oneStop: {
                    title: 'One-Stop Service',
                    desc: 'Our solutions cover both software and hardware with unified end-to-end alignment, eliminating multi-party coordination, shortening development cycles, and reducing communication costs.'
                },
                custom: {
                    title: 'Deep Customization',
                    desc: 'Software features are precisely matched with hardware performance, avoiding compatibility issues and ensuring smoother overall operation with lower failure rates.'
                },
                expandable: {
                    title: 'High Scalability',
                    desc: 'Our services reserve expansion interfaces, making it easy for customers to upgrade and expand functionalities based on future needs.'
                },
                deployment: {
                    title: 'Flexible Deployment',
                    desc: 'Whether it is localized private deployment or public cloud deployment, we provide flexible solutions to meet your needs.'
                }
            }
        },
        cta: {
            title: 'Ready to upgrade your lifestyle?',
            desc: 'Talk to our smart home experts today and let us design the perfect ecosystem for you.',
            button: 'Contact Sales'
        }
    },
    product: {
        nav: {
            panel: 'Control Panels',
            hub: 'Smart Hubs',
            switch: 'Smart Switches',
            curtain: 'Smart Curtains',
            sensor: 'Sensors',
            lighting: 'Smart Lighting',
            security: 'Smart Security',
            doorlock: 'Smart Door Locks'
        },
        desc: {
            panel: 'Visual control terminal for whole-home smart systems, providing centralized management of devices such as lights, curtains, air conditioning etc. supporting custom scenes and automation',
            hub: 'Multi-protocol smart gateway with WiFi, Zigbee, and Bluetooth connectivity for seamless device integration',
            switch: 'Wi‑Fi and Zigbee 3.0 smart switches available in touch and button versions.',
            curtain: 'Silent curtain motor with remote control, supporting magnetic limit and OTA firmware upgrades',
            sensor: 'Comprehensive environmental monitoring with real-time push notifications for smoke, gas, and water leaks',
            lighting: 'Smart lighting systems with dimmable and color-tunable lamps for personalized ambiance',
            security: 'Whole-home intelligent security alarm system provides real-time monitoring and instant alert for your property.',
            doorlock: 'Smart lock enables keyless access and secure remote management for your home.'
        },
        sub: {
            '4inch': '4-Inch',
            '5inch': '5-Inch',
            '6inch': '6-Inch',
            '7inch': '7-Inch',
            '8inch': '8-Inch',
            '10inch': '10-Inch',
            'touchswitch': 'Touch Switch',
            'buttonswitch': 'Button Switch',
            'sockets': 'Socket',
            'hiddenswitch': 'Hidden Switch',
            'wireless': 'Wireless',
            'wired': 'Wired',
            'openclose': 'Curtain Motor',
            'roller': 'Roller Blind',
            'downlight': 'Downlights & Spotlights',
            'magnetic': 'Magnetic Track Lights',
            'strip': 'Light Strips',
            'alarm': 'Alarm Host',
            'door': 'Door/Window Sensor',
            'smoke': 'Smoke Detector',
            'infrared': 'Infrared Detector',
            'radar': 'Human Presence Radar',
            'water': 'Water Leak Sensor',
            'temp': 'Temp & Humidity Sensor',
            'indoorCam': 'Indoor Camera',
            'outdoorCam': 'Outdoor Camera',
            'password': 'Password Lock',
            'fingerprint': 'Fingerprint Lock',
            'face': 'Face Recognition Lock'
        },
        common: {
            all: 'All',
            learnMore: 'Learn More',
            addToCart: 'Add to Cart',
            buyNow: 'Buy Now',
            emptyProduct: 'No related products yet. Please stay tuned...'
        },
        cart: {
            titleList: 'Request List',
            titleForm: 'Fill in Contact Info',
            empty: 'Your list is empty, go add some products!',
            delete: 'Delete',
            totalItems: 'Total of {count} selected products',
            nextStep: 'Next Step: Fill Information',
            submit: 'Submit Request'
        },
        form: {
            name: 'How should we address you?',
            namePlaceholder: 'Please enter your name',
            address: 'Company Address',
            addressPlaceholder: 'Please enter your detailed company address',
            location: 'City / Country',
            locationPlaceholder: 'e.g., Beijing, China',
            whatsapp: 'WhatsApp',
            whatsappPlaceholder: 'Enter your WhatsApp so we can contact you',
            email: 'Email',
            emailPlaceholder: 'Enter your email so we can contact you',
            remark: 'Remarks',
            remarkPlaceholder: 'Enter any remarks so we can better understand your needs',
            zipCode: 'Zip/Postal Code',
            zipCodePlaceholder: 'Please enter your zip or postal code'
        },
        alert: {
            fillRequired: 'Please fill in all required fields (marked with *)',
            submitSuccess: 'Request submitted successfully! Our sales team will contact you shortly.',
            confirm: 'Confirm',
            notice: 'Notice',
            success: 'Success!',
            error: 'Error',
            invalidRequest: 'Invalid request',
            rateLimit: 'Too many requests. Please try again in {seconds} seconds.',
            invalidEmail: 'Please enter a valid email address',
            invalidPhone: 'Please enter a valid phone number',
            dangerousContent: 'Input contains invalid or unsupported characters. Please check and try again.',
            cartEmpty: 'No valid items in the cart',
            securityCheck: 'Please complete the security verification first',
            submitFailed: 'Submission failed, please try again later'
        }
    },
    contact: {
        hero: {
            title: 'Contact Us',
            desc: 'Get professional advice and the most suitable solutions for you'
        },
        form: {
            title: 'Send us a message',
            subtitle: "Fill out the form below and we'll get back to you within 24 hours.",
            firstName: 'First Name',
            firstNamePlaceholder: 'e.g., Jane',
            lastName: 'Last Name',
            lastNamePlaceholder: 'e.g., Doe',
            email: 'Work Email',
            emailPlaceholder: "jane{'@'}company.com",
            inquiryType: 'Inquiry Type',
            selectTopic: 'Select a topic...',
            message: 'Message',
            messagePlaceholder: 'How can we help you?',
            submitBtn: 'Send Message',
            sending: 'Sending...',
            successMsg: 'Thank you! Your message has been sent successfully.'
        },
        inquiry: {
            general: 'General Question',
            sales: 'Sales & Distribution',
            support: 'Technical Support',
            hardware: 'OEM/ODM'
        },
        location: {
            title: 'Where We Are',
            officeName: 'Shenzhen Headquarters',
            address: 'Room 603, Unit 1, Building 1, Kailifang Plaza, Lianrun Road, Taoyuan Community, Dalang Street, Longhua District, Shenzhen, Guangdong, China',
            phone: '+86 18926403313 Ms. Yuan'
        }
    },
    footer: {
        companyName: 'Shenzhen Golden Security Technology Co., Ltd.'
    }
}